<template>
    <v-btn :to="{ name: to_name }"
                 class="menuBtn">
      <v-container fluid>
        <v-row>
          <v-col cols="12" class="pa-2">
            <v-icon>{{ svgPathComputed }}</v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-2">
            {{ submenuComputed }}
          </v-col>
        </v-row>
      </v-container>
    </v-btn>
</template>

<script>
export default {
  name: 'IconBtn',
  props: ['svgPath',
    'submenu',
    'id_svgPath',
    'id_submenu',
    'to_name',
    'change'
  ],
  data () {
    let changeData = true
    if (this.change !== undefined) {
      changeData = this.change
    }
    let id_list = []
    if (this.id_svgPath) {
      id_list.push(this.id_svgPath)
    }
    if (this.id_submenu) {
      id_list.push(this.id_submenu)
    }
    let _svgPath = this.valueDict(this.svgPath, this.id_svgPath)
    let _submenu = this.getT18nData(this.submenu, this.id_submenu)
    let letThis = this
    new Promise(function (resolve, reject) {
      letThis.$store.dispatch('contentChanges/GET_CONTENT', { 'id_list': id_list })
        .then(() => {
          let content = letThis.$store.getters['contentChanges/content']
          for (let cont_item of content) {
            if (cont_item['id_content'] === parseInt(letThis.id_submenu)) {
              _submenu['value_rus'] = cont_item['value_rus']
              _submenu['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_svgPath)) {
              _svgPath['value_rus'] = cont_item['value_rus']
              _svgPath['value_eng'] = cont_item['value_eng']
            }
          }
        })
    })
    return {
      submenuData: _submenu,
      svgPathData: _svgPath,
      changeData: changeData
    }
  },
  computed: {
    submenuComputed () {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.submenuData['value_rus'] = this.submenu }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.submenuData['value_eng'] = this.submenu }
      if (this.$i18n.locale == 'ru') { return this.submenuData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.submenuData['value_eng'] }
    },
    svgPathComputed () {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.svgPathData['value_rus'] = this.svgPath }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.svgPathData['value_eng'] = this.svgPath }
      if (this.$i18n.locale == 'ru') { return this.svgPathData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.svgPathData['value_eng'] }
    }
  },
  methods: {
    getT18nData (i18n_data, id_content) {
      let ru_value = Object.entries(this.$i18n.messages['ru']['message']).filter(value => value[1] == i18n_data)
      if (ru_value.length!=0) {
        return { 'value_rus': this.$i18n.messages['ru']['message'][ru_value[0][0]],
          'value_eng': this.$i18n.messages['en-US']['message'][ru_value[0][0]],
          'id_content': id_content
        }
      }
      let eng_value = Object.entries(this.$i18n.messages['en-US']['message']).filter(value => value[1] == i18n_data)
      if (eng_value.length!=0) {
        return { 'value_rus': this.$i18n.messages['ru']['message'][eng_value[0][0]],
          'value_eng': this.$i18n.messages['en-US']['message'][eng_value[0][0]],
          'id_content': id_content
        }
      }
      return { 'value_rus': i18n_data, 'value_eng': i18n_data, 'id_content': this.id_content }
    },
    valueDict (value, id_content) {
      return { 'value_rus': value,
        'value_eng': value,
        'id_content': id_content }
    },
    pushChangeContent () {
      let content_to_change = { 'submenu': this.submenuData,
        'svgPath': this.svgPathData
      }
      this.$store.dispatch('contentChanges/SET_CONTENT_TO_CHANGE', {
        'type_to_change': 'IconBtn',
        'content_to_change': content_to_change
      })
      this.$router.push('/change_content')
    }
  }
}
</script>
